import { isBefore, isEqual } from 'date-fns';

// January 1st at midnight in the local timezone of the user (to allow the user to fetch year 2023 in his local timezone)
const minDate = new Date('2023-01-01 00:00:00');
const useDashboardUnavailableInterval = (startDate: Date, endDate: Date) => {
  return (
    isBefore(startDate, minDate) ||
    isBefore(endDate, minDate) ||
    isEqual(endDate, minDate)
  );
};

export default useDashboardUnavailableInterval;
